<template>
  <v-dialog
    v-model="active"
    width="70%"
    persistent
  >
    <v-card
      color="primary"
      tile
    >
      <v-card-title>
        <div class="text-h6">
          Evaluacion poligráfica
        </div>
        <v-spacer />
        <v-btn
          icon
          color="error"
          @click="closeDialog()"
        >
          <v-icon>mdi-window-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text v-if="evaluacionPoligrafica">
        <v-container>
          <v-row>
            <v-col cols="6">
              <v-text-field
                label="Evaluado"
                :value="getFullName(
                  evaluacionPoligrafica.Derivacion.Programacion.Expediente.Personal)"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                readonly
              />
            </v-col>
            <v-col cols="3">
              <v-text-field
                label="Evaluador que elaboró"
                value="C3DEMO08"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                readonly
              />
            </v-col>
            <v-col cols="3">
              <v-text-field
                label="Evaluador que revisó"
                :value="evaluacionPoligrafica.evaluadorReviso"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                readonly
              />
            </v-col>
          </v-row>
          <v-row />
          <v-row>
            <v-col cols="12">
              <v-textarea
                v-model="evaluacionPoligrafica.antecedentesLaborales"
                label="Antecedentes laborales"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                rows="8"
                no-resize
                readonly
              />
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="evaluacionPoligrafica.situacionPatrimonial"
                label="Situación patrimonial"
                dense
                color="secondary"
                background-color="primary"
                rows="8"
                no-resize
                readonly
                rounded
                filled
              />
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="evaluacionPoligrafica.admisiones"
                label="Admisiones"
                dense
                color="secondary"
                background-color="primary"
                rows="8"
                no-resize
                readonly
                rounded
                filled
              />
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="evaluacionPoligrafica.observaciones"
                label="Observaciones"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                rows="8"
                no-resize
                readonly
              />
            </v-col>
            <v-col
              v-for="(pregunta, index) in evaluacionPoligrafica.preguntas"
              :key="index"
              cols="12"
            >
              <v-text-field
                label="Pregunta"
                :value="pregunta.pregunta"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                readonly
              />
              <v-text-field
                label="Puntaje"
                :value="pregunta.puntaje"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                readonly
              />
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="evaluacionPoligrafica.sintesisTecnica"
                label="Síntesis técnica"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                rows="8"
                no-resize
                readonly
              />
            </v-col>
            <v-row>
              <v-col
                v-for="(indicador, index) in evaluacionPoligrafica.indicadores"
                :key="index"
              >
                <v-text-field
                  label="Indicador"
                  :value="indicador.indicador"
                  rounded
                  filled
                  dense
                  color="secondary"
                  background-color="primary"
                  readonly
                />
              </v-col>
            </v-row>
            <v-col cols="12">
              <v-textarea
                v-model="evaluacionPoligrafica.diagnosticoPreliminar"
                label="Diagnóstico preliminar"
                rounded
                filled
                dense
                color="secondary"
                background-color="primary"
                rows="8"
                no-resize
                readonly
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    active: {
      type: Boolean,
    },

    evaluacionPoligrafica: {
      type: Object,
      required: true,
    },
  },

  methods: {
    closeDialog() {
      this.$emit('close');
    },
  },
};
</script>
